<template>
  <div class="wrapper">
    <div class="main visual-2 avdoc">
      <Header backRoute="/appointments" />

      <!-- Spinner Loader -->
      <div class="spinner" v-if="loading">
        <div class="loader"></div>
        <p>Loading...</p>
      </div>

      <!-- Appointment Status -->
      <div class="appointment-status vis4-inr1" v-else-if="appointment?.id">
        <h1>Appointment Status</h1>
        <table class="appointment-table">
          <tbody>
            <tr>
              <td><strong>Doctor Name:</strong></td>
              <td>
                {{ appointment?.doctor?.firstname }}
                {{ appointment?.doctor?.lastname }}
              </td>
            </tr>
            <tr>
              <td><strong>Patient Name:</strong></td>
              <td>
                {{ appointment?.patient?.firstname }}
                {{ appointment?.patient?.lastname }}
              </td>
            </tr>
            <tr>
              <td><strong>Queue-ID:</strong></td>
              <td>{{ appointment?.qid }}</td>
            </tr>
            <tr>
              <td><strong>Date:</strong></td>
              <td>
                {{
                  new Date(appointment?.slots?.startTime).toLocaleDateString(
                    "en-GB",
                    {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    }
                  )
                }}
              </td>
            </tr>
            <tr>
              <td><strong>Time:</strong></td>
              <td>
                {{
                  new Date(appointment?.slots?.startTime).toLocaleTimeString(
                    [],
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="prnt-btn">
          <button @click="printStatus" class="btn btn-primary">Print</button>
        </div>
      </div>

      <!-- Help Button -->
      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import { PatientTimeSlotsService } from "@/services/patient-time-slots.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "AppointmentStatus",
  data() {
    return {
      appointment: {},
      loading: false,
    };
  },
  created() {
    if (!this.$route.query.id) {
      this.$router.push("/appointments");
      return;
    }
  },

  methods: {
    async getAppointment() {
      this.loading = true; // Show the spinner
      try {
        const response = await PatientTimeSlotsService.getById(
          this.$route.query.id
        );
        console.log("🚀 ~ getAppointment ~ response:", response);
        if (response.success) {
          this.appointment = response.data;
        } else {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: response.message,
          });
          return;
        }
      } catch (error) {
        console.error("Error fetching appointment:", error);
      } finally {
        this.loading = false; // Hide the spinner
      }
    },

    printStatus() {
      try {
        let doctorName =
          this.appointment?.doctor?.firstname +
          " " +
          this.appointment?.doctor?.lastname;
        let patientName =
          this.appointment?.patient?.firstname +
          " " +
          this.appointment?.patient?.lastname;
        let date = new Date(this.appointment?.startTime).toLocaleDateString(
          "en-GB",
          {
            day: "numeric",
            month: "short",
            year: "numeric",
          }
        );
        let time = new Date(this.appointment?.startTime).toLocaleTimeString(
          [],
          {
            hour: "2-digit",
            minute: "2-digit",
          }
        );
        let queueId = this.appointment?.qid;
        window.chrome.webview.hostObjects.bridge.PrintReceipt(
          doctorName,
          patientName,
          queueId,
          date,
          time
        );
        localStorage.removeItem("appointment_status");
        this.$router.push("/good-to-go");
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.getAppointment();
  },
};
</script>

<style scoped>
.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

.loader {
  border: 8px solid #f3f3f3;
  /* Light gray */
  border-top: 8px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.appointment-status {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  font-family: Arial, sans-serif;
}

.appointment-header {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.appointment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 17px;
  background-color: #fff;
}

.appointment-table td {
  padding: 10px 15px;
  border: 1px solid #ddd;
}

.appointment-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.appointment-table td:first-child {
  font-weight: bold;
  color: #34495e;
  text-align: left;
}

.appointment-table td:last-child {
  text-align: right;
  color: #2c3e50;
}
</style>
